import { BlockNodes, type IMenuButton } from '@principle-theorem/editor';
import { type MenuButtonLoaderFn } from '@principle-theorem/ng-prosemirror';
import { BasicMenuButtonComponent } from '../../menu-bar/basic-menu-button/basic-menu-button.component';

const data: IMenuButton = {
  buttonType: 'basic',
  buttonText: 'Horizontal Rule',
  tooltip: 'Horizontal Rule',
  icon: 'remove',
  command: (editor) => editor.chain().focus().setHorizontalRule().run(),
  isActiveFn: (editor) => editor.isActive(BlockNodes.HorizontalRule),
};

export function createHorizontalRuleMenuButton(): MenuButtonLoaderFn<
  BasicMenuButtonComponent,
  IMenuButton
> {
  return () => ({
    component: BasicMenuButtonComponent,
    data,
  });
}

export function createHorizontalRuleBlockMenuButton(): MenuButtonLoaderFn<
  BasicMenuButtonComponent,
  IMenuButton
> {
  return () => ({
    component: BasicMenuButtonComponent,
    data: {
      ...data,
      buttonType: 'block',
    },
  });
}
